import { useQuery } from '@tanstack/react-query';

import { GetHotelBidFailureLogsParams, getHotelBidFailureLogs } from '~/services/PublicOfferFeedService';

export const hotelBidFailureLogQueryKeys = {
  all: ['hotelBidFailureLogs'] as const,
  lists: () => [...hotelBidFailureLogQueryKeys.all, 'list'] as const,
  list: (customerId: string, params: GetHotelBidFailureLogsParams) =>
    [...hotelBidFailureLogQueryKeys.lists(), customerId, params] as const,
};

export function useGetHotelBidFailureLogs(customerId: string | null, params: GetHotelBidFailureLogsParams) {
  return useQuery({
    queryKey: customerId ? hotelBidFailureLogQueryKeys.list(customerId, params) : hotelBidFailureLogQueryKeys.lists(),
    queryFn: async ({ signal }) => {
      // customerId is guaranteed non-null by enabled: !!customerId
      if (!customerId) {
        throw new Error('customerId is required');
      }
      return getHotelBidFailureLogs(customerId, params, { signal });
    },
    enabled: !!customerId,
  });
}
